const publicPath = process.env.VUE_APP_PUBLIC_PATH;
export async function loadSettings() {
    try {
        const response = await fetch(publicPath + 'json/confilmSettings.json');
        if (!response.ok) {
        throw new Error('Failed to fetch JSON data');
        }
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error loading settings:", err);
        throw err;
    }
}